export const FeaturesSection = () => `
  <section class="py-20 bg-white">
    <div class="container mx-auto px-6">
      <div class="text-center mb-16" data-aos="fade-up">
        <h2 class="text-4xl font-bold mb-6">Hvorfor velge Farskapet?</h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">Vi er fedre som forstår dine behov</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        ${[
          {
            icon: '👨‍👦',
            title: 'Fedre for Fedre',
            description: 'Vi vet hva du går gjennom fordi vi har vært der selv'
          },
          {
            icon: '⭐',
            title: 'Kvalitet og Pålitelighet',
            description: 'Nøye utvalgte produkter av høy kvalitet som du kan stole på'
          },
          {
            icon: '🤝',
            title: 'Fellesskap og Støtte',
            description: 'Mer enn en butikk - et fellesskap av fedre'
          },
          {
            icon: '🚚',
            title: 'Rask Levering',
            description: 'Vi sender produktene så fort som mulig'
          },
          {
            icon: '💯',
            title: 'Kundetilfredshet',
            description: '5-stjerners vurderinger fra fornøyde kunder'
          },
          {
            icon: '🇳🇴',
            title: 'Norsk Selskap',
            description: 'Lokalt selskap med fokus på norske familier'
          }
        ].map(feature => `
          <div class="bg-primary rounded-xl p-6 shadow-lg" data-aos="fade-up">
            <div class="text-4xl mb-4">${feature.icon}</div>
            <h3 class="text-xl font-semibold mb-2">${feature.title}</h3>
            <p class="text-gray-600">${feature.description}</p>
          </div>
        `).join('')}
      </div>
    </div>
  </section>
`;